/**
 * Native (Capacitor) platform helpers.
 *
 * The same React bundle runs in the browser and inside the Android WebView, so
 * anything that depends on a real browser window — popups, tab-based OAuth —
 * has to be branched at runtime rather than at build time.
 */

import { Capacitor } from '@capacitor/core';

/** True inside the Android/iOS WebView, false in a normal browser. */
export const isNative = () => Capacitor.isNativePlatform();

/** 'android' | 'ios' | 'web' */
export const getPlatform = () => Capacitor.getPlatform();

/**
 * Start Google sign-in in a popup. The server's result page posts
 * { type: 'social-auth', token, user } or { type: 'social-auth-error', error }
 * back to this window. `returnTo` is where the no-popup fallback lands
 * (default /login); if the popup is blocked we go there through Google in
 * this tab. Browser only: the Android WebView cannot run Google OAuth.
 */
export const openGoogleSignIn = (returnTo) => {
  const url = '/api/auth/google' + (returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : '');
  const w = 500, h = 600;
  const left = window.screenX + (window.outerWidth - w) / 2;
  const top = window.screenY + (window.outerHeight - h) / 2;
  const popup = window.open(url, 'google-login', `width=${w},height=${h},left=${left},top=${top}`);
  if (!popup) window.location.assign(url);
};
